import React from 'react';

import { Button } from '@qality/common-components/src/atoms/Button';
import { ReportLinkCell } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  cell: ReportLinkCell;
};

export default function ReportLink({ cell }: Props): JSX.Element {
  const handleClick = async (): Promise<void> => {
    window.open(
      (await StorageOfUniqueServices.get('HostNameService').baseUrl) + cell
    );
  };

  return (
    <Button marginSize='small' onClick={handleClick}>
      View
    </Button>
  );
}
